import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20with%20warm%20red%20and%20dark%20tones%2C%20minimal%20geometric%20composition%2C%20subtle%20gradient%20from%20dark%20charcoal%20to%20deep%20burgundy%2C%20soft%20atmospheric%20lighting%2C%20modern%20art%20style%2C%20clean%20lines%2C%20elegant%20texture%2C%20dark%20moody%20aesthetic%2C%20no%20text%2C%20abstract%20waves%20and%20flowing%20shapes%2C%20professional%20background&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-20 pb-10">
        <div className="max-w-7xl mx-auto">
          <nav aria-label="面包屑导航" className="mb-6">
            <ol className="flex items-center gap-1.5 text-sm text-background-300/80 flex-wrap">
              <li>
                <Link to="/" className="hover:text-background-50 transition-colors">
                  首页
                </Link>
              </li>
            </ol>
          </nav>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16">
            <div className="flex-1">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-background-50 font-heading leading-tight">
                免费韩漫
                <br />
                <span className="text-primary-400">在线阅读</span>
              </h1>
            </div>

            <div className="flex-1 lg:pt-4">
              <p className="text-base md:text-lg text-background-200/80 leading-relaxed mb-6 max-w-md">
                奇妙漫画网汇集了好看的韩国漫画和韩国漫画大全，无论你喜欢恋爱、奇幻还是动作漫画，这里都能找到心仪的作品。享受个性化推荐和流畅的阅读体验。
              </p>
              <Link
                to="/category/romance"
                className="inline-flex items-center gap-2 whitespace-nowrap text-background-50 text-sm font-medium group cursor-pointer"
              >
                <span>探索漫画分类</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}